module.exports = __webpack_public_path__ + "img/page7.912b85b9.jpg";